var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationSvgform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 5,
    fill: "#2B7FE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8176 46.6914C18.8371 32.3359 17.0598 30.832 17.0598 25.5C17.0598 18.2539 22.8703 12.375 30.1848 12.375C37.4309 12.375 43.3098 18.2539 43.3098 25.5C43.3098 30.832 41.4641 32.3359 31.4836 46.6914C30.8684 47.6484 29.4328 47.6484 28.8176 46.6914ZM30.1848 30.9688C33.1926 30.9688 35.6535 28.5762 35.6535 25.5C35.6535 22.4922 33.1926 20.0312 30.1848 20.0312C27.1086 20.0312 24.716 22.4922 24.716 25.5C24.716 28.5762 27.1086 30.9688 30.1848 30.9688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSvgform);
export default __webpack_public_path__ + "static/media/location_svgform.611653e2ea2eb050c8fcf2a4fe3b6c5b.svg";
export { ForwardRef as ReactComponent };